import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import { UpdateDynamicPageOrderRequest } from '../../../type'
import { updateDynamicPageOrder } from '../../services'

interface UseMutationUpdateSectionOrderInPageProps {
	dynamicPageSectionId: string
	payload: UpdateDynamicPageOrderRequest
}

export default function useMutationUpdateSectionOrderInPage(
	props?: UseBaseMutationOptions<
		void,
		UseMutationUpdateSectionOrderInPageProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.UpdateDynamicPageOrder],
		mutationFn: (params) =>
			updateDynamicPageOrder(params.dynamicPageSectionId, params.payload),
		...props,
	})
}
